import { z } from 'zod'
import { cardanoAddressSchema } from './address'

/** Cardano Tx Hash の実行時検証。 */
export const cardanoTxHashSchema = z.string().regex(/^[0-9a-f]{64}$/)

/** 正規化済み mainnet の鍵由来 Stake 同期キーを検証する。 */
export const cardanoStakeAddressSchema = z
  .string()
  .superRefine((value, context) => {
    const result = cardanoAddressSchema.safeParse(value)
    if (
      !result.success ||
      result.data.type !== 'reward' ||
      result.data.address !== value
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid canonical Cardano stake address',
      })
    }
  })

/**
 * Tx Hash から決定的な Source ID を作る。
 * @param params.txHash オンチェーン Tx Hash
 * @returns Tx の Source ID
 */
export const createCardanoTxSourceId = (params: { txHash: string }): string =>
  `cardano-tx:${cardanoTxHashSchema.parse(params.txHash)}`

/**
 * Tx Hash を持たない配分報酬の Source ID を作る。
 * @param params.stakeAddress 鍵由来 Stake Address
 * @param params.payoutEpoch 利用可能になった配分 Epoch
 * @returns 同じ配分期間を冪等保存できる仮想 Source ID
 */
export const createCardanoRewardSourceId = (params: {
  stakeAddress: string
  payoutEpoch: number
}): string =>
  `cardano-reward:${cardanoStakeAddressSchema.parse(params.stakeAddress)}:${z.number().int().nonnegative().safe().parse(params.payoutEpoch)}`
